<template>
    <div class="display-node-content-outer">
        
        <transition name="fade-faster" mode="out-in">
            <div 
                v-if="loadingNode"
                key="loading"
                class="w-100 d-flex align-items-center justify-content-center min-height-120"
            >
                <b-spinner></b-spinner>
            </div>
            <div 
                v-else-if="displayContent"
                key="loadedHasContent"
                class="display-node-content-inner w-100 h-100" 
                v-html="displayContent"
            ></div>
        </transition>

    </div>
</template>

<script>
import FlowNodeContentMixin from './FlowNodeContentMixin';

export default {
    name: 'FlowNodeDisplay',
    components: {},
    mixins: [
        //errorHandling,
        FlowNodeContentMixin,  // not a 'task' itself, but actually is same as other ones that use this - should call it 'NodeContentMixin'
    ],
    props: {
        // all props come from mixin
        // nodeData: {  // pass in from localNodeData in Task component so its got all the detail
        //     type: Object,
        //     required: true,
        // },
        // nodeContext: {  // node-level context, with info/methods on calling transitions
        //     type: Object,
        //     required: true,  
        // },
    },
    data() {
        return {
            // errorMsg: 'Error',
            // error: false,
            
        }
    },
    computed: {
        // lots of stuff from mixin!
        displayContent() {
            // return the HTML string of content to show 
            // or should we be using render() function here??? maybe later, could do more complex things
            return this.nodeData.content ?? '';
        },
        loadingNode() {
            return this.nodeContext.loadingNode;
        },
    },
    mounted() {
        
    },
    methods: {
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage

    }
}
</script>

<style>

</style>